import React from 'react';
import { useLocation } from 'react-router-dom';
import { Tabs } from '@cochlear-design-system/foundation';
import { getTabContent } from './TabContent';

export const SummaryPanel = ({
  config,
  data,
  country,
  labels,
  lang,
  leftData,
  rightData,
  unknownData,
  rcData,
  rcRemoteModuleKey,
  useModuleFederationSR,
  providerRegion,
  patientId,
}) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tabQuery = queryParams.get('tab');

  let initialTabIndex = 0;

  const tabs = [
    {
      id: 'view_devices_view_patient',
      label: labels[config.labels.equipment],
    },
  ];
  if (config.serviceRequestConfig.enabled) {
    tabs.push({
      id: 'view_service_requests_view_patient',
      label: labels[config.labels.serviceRequests],
    });
  }
  if (config.remoteCheckConfig.enabled) {
    tabs.push({
      id: 'view_remote_check_view_patient',
      label: labels[config.labels.remoteCheck],
    });
  }

  if (tabQuery === 'remote-check') {
    // Default to remote-check tab
    if (config.remoteCheckConfig.enabled) {
      initialTabIndex += 1;
      if (config.serviceRequestConfig.enabled) {
        initialTabIndex += 1;
      }
    }
  } else if (tabQuery === 'service-requests') {
    if (config.serviceRequestConfig.enabled) {
      initialTabIndex += 1;
    }
  }

  return (
    <Tabs
      data={{
        tabs,
      }}
      config={{ contentAsCard: true, initialTabIndex }}
    >
      {getTabContent(
        config,
        data,
        country,
        labels,
        lang,
        leftData,
        rightData,
        unknownData,
        rcData,
        rcRemoteModuleKey,
        useModuleFederationSR,
        providerRegion,
        patientId,
      )}
    </Tabs>
  );
};
